angular.module('impactx.basketLink').service('AddToBasketService', BasketLinkService);

BasketLinkService.$inject = ['dataGen', '$mdToast', '$context', '$redirect', '$mdDialog', 'themeFactory', 'basketTemplateMenu', '$securityManager', '$q', 'AppConfiguration', 'ixaSearchSignals'];

function BasketLinkService(dataGen, $mdToast, $context, $redirect, $mdDialog, themeFactory, basketTemplateMenu, $securityManager, $q, AppConfiguration, ixaSearchSignals) {
    var self = this;

    function replaceInBasket(productId, oldBKIId, actionTrns) {
        var dataObj = {};
        dataObj.newItem = {productId: productId, prgId: 0};
        dataObj.oldBKIId = oldBKIId;
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/basket/item/replace").then(function () {
            $context.refreshBasket({}, dataGen, $context);
            if ($context.basketIsUserTemplate) {
                basketTemplateMenu.refreshUserTemplates();
            }
            if ($context.basketIsCompanyTemplate) {
                basketTemplateMenu.refreshOwnCompanyTemplates();
            }
            $mdToast.show(
                $mdToast.simple()
                    .textContent(tempScope.trns.success)
                    .position("bottom right")
                    .hideDelay(5000).action(actionTrns).theme(themeFactory.getTheme()).highlightAction(true)
            ).then(function (value) {
                if (value == 'ok') {
                    if ($context.hasSupplierBasket.value) {
                        $redirect.redirectTo(null, "/supplierbasket")
                    }
                    else {
                        $redirect.redirectTo(null, "/basket");
                    }
                }
            });
        });
    }

    function replaceInBasketParamObject(selectedProduct, paramObject) {
        return replaceInBasket(selectedProduct.id, paramObject.oldBKIId, paramObject.actionTrns);
    }

    function addProductToBasket(event, product, vCatId) {
        var basketLink = product.basketLink;
        return addToBasket(product, basketLink.amount, basketLink.actionLabel, basketLink.price.askSupplier, event, vCatId);
    }

    function addExternalProductToBasket(event, product, amount) {
        var basketLink = product.basketLink;
        var defer = $q.defer();

        var tempScope = {};
        if (amount) {
            product.amount = amount;
        } else if(impactX.isDefined(product, 'basketLink.price.minAmountFormatted')) {
            product.amount = product.basketLink.price.minAmountFormatted
        }
        dataGen.postAsForm(tempScope, {toAdd: product}, "/basket/externalproduct/add").then(function () {
            $context.refreshBasket({}, dataGen, $context);
            if ($context.basketIsUserTemplate) {
                basketTemplateMenu.refreshUserTemplates();
            }
            if ($context.basketIsCompanyTemplate) {
                basketTemplateMenu.refreshOwnCompanyTemplates();
            }
            showActionToast(tempScope.trns.success, tempScope.trns.successSecond, basketLink.actionLabel);
            defer.resolve();
        }, function () {
            defer.resolve();
        });

        return defer.promise;
    }

    function selectSupplier(event, product) {
        $mdDialog.show({
            controller: "SupplierSelectionDialogCtrl",
            controllerAs: "supplierSelectionDialogCtrl",
            templateUrl: 'shared/basketlink/templates/supplierselection.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                proId: product.id,
                amount: product.basketLink.amount
            }
        });
    }

    function showSelectReferenceDialog(event, product, actionTrns, defer) {
        $mdDialog.show({
            controller: "SelectReferenceDialogCtrl",
            controllerAs: "selectReferenceDialogCtrl",
            templateUrl: 'shared/basketlink/templates/selectreference.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                proId: product.id,
                bkiId: 0,
                canDecideLater: false
            }
        }).then(function (message) {
            showActionToast(message, '', actionTrns);
            defer.resolve();
        }, function () {
            defer.resolve();
        });
    }

    function addToBasketDefault(product, vCatId, amount, event, actionTrns, defer, selectReferenceToLinkId) {
        var dataObj = {
            toAdd: []
        };
        dataObj.toAdd.push({
            productId: product.id,
            prgId: 0,
            vCatId: (vCatId && vCatId > 0) ? vCatId : 0,
            amount: amount,
            selectReferenceToLinkId: selectReferenceToLinkId ? selectReferenceToLinkId : 0
        });

        dataGen.postAsForm({}, {toAdd: dataObj.toAdd[0]}, "/basket/checkorderlimit").then(function (response) {
            if (impactX.isDefined(response, 'data.hasError')) {
                showOrderLimitDialog(response.data, event).then(function () {
                    if (impactX.isDefined(response, 'data.changedAmount')) {
                        dataObj.toAdd[0].amount = response.data.changedAmount;
                    }
                    addToBasketInternal(dataObj, product, event, actionTrns, defer);
                }, function () {
                    defer.resolve();
                });
            }
            else {
                addToBasketInternal(dataObj, product, event, actionTrns, defer);
            }
        }, function () {
            defer.resolve();
        });
    }

    function addToBasket(product, amount, actionTrns, askSupplier, event, vCatId) {
        var defer = $q.defer();
        if (!amount || amount == 0) {
            if (!product.isCompilationArticle) {
                if (product.basketLink.price.minAmountFormatted && product.basketLink.price.minAmountFormatted.length > 0) {
                    amount = product.basketLink.price.minAmountFormatted;
                }
                else {
                    amount = product.basketLink.price.minAmount;
                }
            }
            else {
                amount = 1;
            }
        }

        if (askSupplier && $securityManager.isProcessAllowed("DecideRFQ")) {

            $mdDialog.show({
                controller: "DecideRFQCtrl",
                controllerAs: "decideRFQCtrl",
                templateUrl: 'modules/rfq/templates/deciderfq.html',
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    proId: product.id,
                    amount: amount
                }
            }).then(function (message) {
                const proId = product.groupNumber > 0? product.groupNumber : product.id;
                ixaSearchSignals.cart(proId);
                showActionToast(message, '', actionTrns);
                defer.resolve();
            }, function () {
                defer.resolve();
            });
        }
        else if (product.isSelectMainOrComponent) {
            if (!product.isSelectComponent && AppConfiguration.get('automaticSelectGroupCreation')) {

                dataGen.getData({}, {productId: product.id}, "/basket/selectreference/checkexisting", null, true).then(function (data) {
                    if (data && data.data && data.data.bkiId && data.data.bkiId > 0) {
                        addToBasketDefault(product, vCatId, amount, event, actionTrns, defer, data.data.bkiId);
                    }
                    else {
                        showSelectReferenceDialog(event, product, actionTrns, defer);
                    }
                });
            }
            else {
                showSelectReferenceDialog(event, product, actionTrns, defer);
            }
        }
        else {
            addToBasketDefault(product, vCatId, amount, event, actionTrns, defer, 0);
        }
        return defer.promise;
    }

    function addToBasketInternal(dataObj, product, event, actionTrns, defer) {
        var tempScope = {};
        // awaitWarnings=true: the promise resolves only after the user dismissed a shown warning
        // (e.g. "maximum order quantity exceeded"), so the follow-up dialogs below open afterwards
        // instead of tearing the warning down. See IOBL-15395.
        dataGen.postAsForm(tempScope, dataObj, "/basket/items/add", undefined, undefined, undefined, true).then(function () {
            const proId = product.groupNumber > 0? product.groupNumber : product.id;
            ixaSearchSignals.cart(proId);
            $context.refreshBasket({}, dataGen, $context);
            if ($context.basketIsUserTemplate) {
                basketTemplateMenu.refreshUserTemplates();
            }
            if ($context.basketIsCompanyTemplate) {
                basketTemplateMenu.refreshOwnCompanyTemplates();
            }
            var bkiId = impactX.isDefined(tempScope, 'data.addedItemId');
            if(impactX.isDefined(tempScope, 'data.product')) {
                updateProductData(product, tempScope);
            }
            if (bkiId && product.isCatering) {
                showCateringDialog(product, bkiId, event).then(function () {
                    showActionToast(tempScope.trns.success, tempScope.trns.successSecond, actionTrns);
                    defer.resolve();
                }, function () {
                    defer.resolve();
                });
            }
            else {
                handleDialogs(bkiId, tempScope, event, actionTrns, defer);
            }
        }, function () {
            defer.resolve();
        });
    }

    function handleDialogs(bkiId, tempScope, event, actionTrns, defer) {
        if (bkiId && impactX.isDefined(tempScope, 'data.hasVariableProductAttributes')) {
            showAttributesDialog(bkiId, event).then(function () {
                showActionToast(tempScope.trns.success, tempScope.trns.successSecond, actionTrns);
                defer.resolve();
            }, function () {
                defer.resolve();
            })
        } else if (bkiId && impactX.isDefined(tempScope, 'data.hasVariableProductAttributesOnRepeat')) {
            showAttributesDialogBasketAddRepeat(bkiId, event).then(function () {
                showActionToast(tempScope.trns.success, tempScope.trns.successSecond, actionTrns);
                defer.resolve();
            }, function () {
                defer.resolve();
            })
        } else {
            showActionToast(tempScope.trns.success, tempScope.trns.successSecond, actionTrns);
            defer.resolve();
        }
    }

    function updateProductData(product, tempScope)
    {
        // Update product data if necessary
        product.inBasket = tempScope.data.product.inBasket;
        product.amountInBasket = tempScope.data.product.amountInBasket;
        product.amountInBasketString = tempScope.data.product.amountInBasketString;
    }

    function showCateringDialog(product, bkiId, event) {
        return $mdDialog.show({
            controller: "CateringDialogCtrl",
            controllerAs: "cateringDialogCtrl",
            templateUrl: 'modules/basket/templates/catering.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                bkiId: bkiId
            }
        });
    }

    function showAttributesDialog(bkiId, event) {
        return $mdDialog.show({
            controller: "BasketAttributesCtrl",
            controllerAs: "basketAttributesCtrl",
            templateUrl: 'modules/basket/templates/basketattributes.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                bkiId: bkiId
            }
        });
    }

    function showAttributesDialogBasketAddRepeat(bkiId, event) {
        return $mdDialog.show({
            controller: "BasketAttributesOnRepeatCtrl",
            controllerAs: "basketAttributesCtrl",
            templateUrl: 'modules/basket/templates/basketattributes.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                bkiId: bkiId
            }
        });
    }

    function showOrderLimitDialog(orderLimit, event) {
        return $mdDialog.show({
            controller: "OrderLimitErrorDialogCtrl",
            controllerAs: "ctrl",
            templateUrl: 'modules/basket/templates/order-limit.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                data: orderLimit
            }
        });
    }

    function showActionToast(message, secondMessage, actionTrns) {
        $mdToast.show({
            templateUrl: 'modules/basket/includes/basket-action-toast-template.html',
            hideDelay: 5000,
            preserveScope: true,
            position: "bottom right",
            controller: "BasketActionToastCtrl",
            controllerAs: 'basketActionToastCtrl',
            locals: {
                message: message,
                secondMessage: secondMessage,
                action: actionTrns
            }
        });
    }

    function addFreeform(product, ev) {
        //always use the classic dialog, for free form products
        if (product) {
            //Default routes and controller
            var entryPointGet = "/basket/item/freeform/fromproduct/view";
            entryPointSave = "/basket/item/freeform/save";
            controller = "EditFreeFormCtrl";
            lotId = 0;

            $mdDialog.show({
                controller: controller,
                templateUrl: 'shared/requestitem/templates/requestitemdialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    itemId: 0,
                    headerId: 0,//$scope.data.basket.id,
                    entryPointGet: entryPointGet,
                    entryPointSave: entryPointSave,
                    changeAATEntryPoint: '/basket/item/updateavailablecontrols',
                    lotId: lotId,
                    productId: product.id,
                    readOnly: false,
                    materialGroupMappingEntryPoint: "/basket/input/eclassmapping",
                    hideOrderData: false,
                    headerTable: "BKH",
                    contractId: 0
                }
            }).then(function () {
                $context.refreshBasket({}, dataGen, $context);
                // $scope.deleteBasketItemSelection();
                // $scope.getBasket();
            }, function () {
                //Here error messaging...
            });
        }
    }

    return {
        replaceInBasket: replaceInBasket,
        replaceInBasketParamObject: replaceInBasketParamObject,
        addToBasket: addToBasket,
        showAttributesDialog: showAttributesDialog,
        addFreeform: addFreeform,
        addProductToBasket: addProductToBasket,
        addExternalProductToBasket: addExternalProductToBasket,
        selectSupplier: selectSupplier,
        showCateringDialog: showCateringDialog
    };
}
